<template>
  <div class="timeline-position-cards" v-loading="loadingTimeline">
    <template v-if="showNoDataMsg">
      <span class="no-data-msg">{{
        $t("statsTimeline.timelinePositionCards.noDataMsg")
      }}</span>
    </template>
    <template v-else>
      <transition-group name="slide-down" tag="div" class="timeline-cards">
        <div
          v-for="pos in timelinePositions"
          :key="pos.enterTs"
          class="timeline-card"
          :class="{
            'timeline-card--future': pos.future,
            'timeline-card--current': pos.current,
            'timeline-card--past': pos.past
          }"
        >
          <div class="timeline-card__container">
            <el-tag
              :type="pos.future ? 'info' : pos.current ? 'success' : ''"
              size="mini"
            >
              <template v-if="pos.future">
                {{ $t("statsTimeline.timelinePositionCards.next") }}
              </template>
              <template v-else-if="pos.current">
                {{ $t("statsTimeline.timelinePositionCards.current") }}
              </template>
              <template v-else>
                {{ $t("statsTimeline.timelinePositionCards.past") }}
              </template>
            </el-tag>
            <div class="timeline-card__content">
              <div>
                <span
                  :class="[
                    'timeline-card__content--position-label',
                    { current: pos.current }
                  ]"
                >
                  {{
                    pos.tagLabel?.length
                      ? pos.tagLabel
                      : `" " (ID: ${pos.tagId})`
                  }}
                </span>
              </div>
              <div class="timeline-card__content--details">
                <span :class="['sm-text', { current: pos.current }]">
                  {{
                    pos.enterTs
                      ? moment
                          .unix(pos.enterTs)
                          .tz(clientData.timezone)
                          .format("DD-MM-YYYY HH:mm:ss")
                      : ""
                  }}
                </span>
                <div
                  v-if="
                    clientData.type === 0 &&
                      pos.ord !== undefined &&
                      pos.ord !== null
                  "
                >
                  <span :class="['sm-text', { current: pos.current }]">
                    {{ $t("statsTimeline.timelinePositionCards.order") }}:
                    {{ pos.ord }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition-group>
    </template>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { mapState } from "vuex";
export default {
  name: "TimelinePositionCards",
  props: {
    timelinePositions: {
      type: Array,
      default: () => []
    },
    loadingTimeline: {
      type: Boolean,
      default: false
    },
    showNoDataMsg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      moment
    };
  },
  computed: {
    ...mapState("clients", {
      clientData: "data"
    })
  }
};
</script>

<style lang="scss">
.timeline-position-cards {
  position: relative;
  margin-top: 16px;

  .timeline-card {
    display: block;
    margin-bottom: 10px;
    padding: 12px 16px;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    transition: all 0.9s;

    &--current {
      border-left: 4px solid #67c23a;
    }
    &--future {
      border-left: 4px solid #409eff;
    }
    &--past {
      border-left: 4px solid #dcdfe6;
    }

    &__container {
      display: grid;
      justify-items: start;
      grid-gap: 4px;
      grid-template-columns: 20% 1fr;
    }
    .timeline-card__content {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 4px;
      text-align: left;
      width: 100%;

      &--position-label {
        font-size: 14px;
      }
      &--details {
        display: flex;
        justify-content: space-between;
        gap: 16px;
        color: #65778b;

        .sm-text {
          font-size: 13px;
        }
      }
    }
  }
}
.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.slide-down-leave-active {
  position: absolute;
  left: 0;
  right: 0;
}

.current {
  font-weight: 600;
  color: #2c3e50;
}
.no-data-msg {
  display: block;
  text-align: center;
  color: #909399;
  font-size: 14px;
  padding: 20px 0;
}
</style>
